import { useTranslation } from 'react-i18next'

import { InputField } from '../../Input'
import { Skeleton } from '../../Skeleton'

import * as styles from './TableModalSearch.module.css'

import SearchIcon from '../../../icons/search.svg'

function TableModalSearch({
  AfterIcon = SearchIcon,
  isSkeleton,
  placeholder = 'Email.AttachedThreadsSearchPlaceholderKey',
  skeletonClassName = styles.skeleton,
  wrapperClassName,
  onChange,
  onClear,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <>
      {isSkeleton ? (
        <Skeleton className={skeletonClassName} />
      ) : (
        <InputField
          {...restProps}
          afterIconProps={{ Icon: AfterIcon }}
          placeholder={t(placeholder)}
          wrapperClassName={wrapperClassName}
          onChange={onChange}
          onClear={onClear}
        />
      )}
    </>
  )
}

export default TableModalSearch
